import { useRef, useImperativeHandle } from 'react';
// components
import Editor from '@monaco-editor/react';
// utils
import { editor } from 'monaco-editor';
import { IRunnerType } from '@newo/api/gateway';
import { editorOptions } from '@/modules/CodeEditor/CodeEditor.data.ts';

interface MonacoEditorProps {
    ref: React.RefObject<{ setValue: (script: string) => void } | null>;
    value: string;
    onChange: (value?: string) => void;
    path: string;
    language: IRunnerType;
}

const languageMap = new Map<string, string>([
    ['guidance', 'handlebars'],
    ['nsl', 'twig']
]);

const CodeEditor = ({
    ref,
    value,
    onChange,
    path,
    language
}: MonacoEditorProps) => {
    const editorRef = useRef<editor.IStandaloneCodeEditor | null>(null);

    useImperativeHandle(ref, () => ({
        setValue: (script: string) => {
            return editorRef.current?.getModel()?.setValue(script);
        }
    }));

    const handleEditorDidMount = (instance: editor.IStandaloneCodeEditor) => {
        editorRef.current = instance;
    };

    return (
        <Editor
            defaultValue={value}
            height="100%"
            language={languageMap.get(language)}
            options={editorOptions}
            path={path}
            theme="newo"
            onChange={onChange}
            onMount={handleEditorDidMount}
        />
    );
};

export default CodeEditor;
